import { useState } from 'react';

import { Box, Heading, ListRow, Separator, Switch, Text } from '@betterment/samba-react';

import { ControlSettingsProps } from './SettingsControls';

const SettingsControlCard: React.FC<ControlSettingsProps> = ({
  title,
  icon,
  subtitle,
  defaultChecked,
  detailModal,
  switchTextHandler,
  name,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(defaultChecked || false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  };

  const switchAriaLabel = `${title} ${isChecked ? 'Selected' : 'Not Selected'}`;

  return (
    <Box
      css={{
        display: 'grid',
        gap: 'space.200',
        padding: 'space.200',
        border: '1px solid',
        borderColor: 'border.weak',
        borderRadius: 'medium',
      }}
    >
      <ListRow css={{ padding: 'space.0' }}>
        <ListRow.LeadingAsset>{icon}</ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <Box css={{ display: 'grid' }}>
            <Heading as="h2" variant="title100">
              {title}
            </Heading>
            {subtitle && (
              <Text as="p" variant="text50" color="text.success">
                {subtitle}
              </Text>
            )}
          </Box>
        </ListRow.LeadingContent>
        <ListRow.TrailingContent>
          <Box css={{ display: 'grid', gap: 'space.100', justifyItems: 'center' }}>
            <Switch
              formStrategy="vanilla"
              value={isChecked ? 'checked' : 'unchecked'}
              name={name}
              defaultChecked={defaultChecked}
              onCheckedChange={handleClick}
              aria-label={switchAriaLabel}
            />
            <Text variant="text25" color="text.weak">
              {switchTextHandler(isChecked)}
            </Text>
          </Box>
        </ListRow.TrailingContent>
      </ListRow>
      <Separator />
      {detailModal}
    </Box>
  );
};

export default SettingsControlCard;
